module.exports = __webpack_public_path__ + "static/media/home-photo.2d76439a.jpg";